<template>
  <div>
    <notification-template
        :large="large"
        :hash="notification.id"
        :urlProfilePhoto="teacher.urlProfilePhoto">
      <template v-slot:header>
        <h1 class="text-orange-academy-300">
          {{$t('notifications.youHaveBookedLesson')}}
        </h1>
      </template>
      <template v-slot:actions>
        <div>
          {{$t('notifications.youHaveBooked')}}
          <router-link :to="`/teachers/${teacher.slug}`" class="font-medium">
            {{ teacher.name }}
          </router-link>
        </div>
        <div class="flex justify-center">
          <button class="flex rounded-sm p-2 text-orange-academy-300 uppercase
            border opacity-60 hover:opacity-100 border-orange-academy-300 items-center"
            @click="contact(user, teacher.user)"
          >
            <message-icon class="w-5"/>
            <span class="pl-3">
            {{$t('notifications.sendMessage')}} {{ teacher.name }}
            </span>
          </button>
        </div>
      </template>
    </notification-template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import StreamFunctionsMixin from '../../mixins/StreamFunctionsMixin';
import MessageIcon from '../graphics/MessageIcon.vue';
import NotificationTemplate from './NotificationTemplate.vue';

export default {
  props: {
    notification: {
      type: Object,
      default: () => {},
    },
    large: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      lesson: { ...this.notification.data.lesson },
      student: { ...this.notification.data.student },
      teacher: { ...this.notification.data.teacher },
    };
  },
  components: { MessageIcon, NotificationTemplate },
  mixins: [StreamFunctionsMixin],
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },
  methods: {
    ...mapActions({
      toggleNotifications: 'toggleNotifications',
    }),
    goToDashboard() {
      if (!this.large) {
        this.toggleNotifications();
        this.$router.push(`/teacher-dashboard#${this.notification.id}`).catch(() => {});
      }
    },
  },
};
</script>
